import React from 'react';
import ReactTooltip from 'react-tooltip';

import { withStyles } from 'src/app/helpers/styles';

type MyProps = {}

interface MyState {
  isMounted: boolean;
}

@withStyles(require('./Tooltip.scss'))
export class Tooltip extends React.Component<MyProps, MyState> {
  constructor(props: MyProps) {
    super(props);

    this.state = {
      isMounted: false
    };
  }

  componentDidMount(): void {
    this.setState({
      isMounted: true
    });
  }

  render(): JSX.Element | null {
    if (!this.state.isMounted) {
      return null;
    }
    return (
      <ReactTooltip class="px-12 py-4 tooltip-base" />
    );
  }
}
